import { CampoForm } from './CampoForm';

export class TipiCampoForm {
  static types: CampoForm[] = [];

  static initialize() {
    if (this.types.length === 0) {
      this.addTipo('numero', 'Numero', 0);
      this.addTipo('testo', 'Testo', 1);
      this.addTipo('data', 'Data', 2);
      this.addTipo('combo', 'Combo', 3);
      this.addTipo('mail', 'Mail', 4);
      this.addTipo('telefono', 'Telefono', 5);
      this.addTipo('password', 'Password', 6);
      this.addTipo('multiselect', 'MultiSelect', 7);
      this.addTipo('file_upload', 'File Upload', 8);
      this.addTipo('note', 'Note', 9);
      this.addTipo('comuni', 'Comuni', 10);
      this.addTipo('aziende', 'Aziende', 11);
      this.addTipo('dipendenti', 'Dipendenti', 12);
      this.addTipo('sedi', 'Sedi', 13);
      this.addTipo('ora', 'Ora', 14);
      this.addTipo('attivita', 'Attività', 15);
    }
  }

  static addTipo(name: string, label: string, type: number): void {
    const campo = new CampoForm();
    campo.name = name;
    campo.label = label;
    campo.type = type;
    this.types.push(campo);
  }

  static getTypes(): CampoForm[] {
    return this.types;
  }
}
